import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxibookinginshirdi() {



    const cardData = {





keyword: "Taxi Booking in Shirdi",
headingDescription: "Sai Shirdi Cab offers easy and dependable taxi booking in Shirdi for passengers planning local transfers, airport pickups, railway station travel, family journeys, pilgrimage trips, business travel, and outstation transportation. Customers can book a suitable taxi according to their passenger count, luggage requirements, destination, and travel schedule. For travelers heading outside Shirdi, Sai Shirdi Cab provides convenient cab booking options for one-way journeys, round trips, return travel, and customized multi-destination trips. The service is designed to make advance taxi booking simple, with planned pickup and drop arrangements and experienced drivers for comfortable travel. Whether you are starting your journey from Shirdi for a nearby pilgrimage destination or planning a longer Maharashtra outstation trip, Sai Shirdi Cab can help arrange reliable transportation around your itinerary.",

topPlaces: [
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a great outstation choice for families, couples, friends, and groups planning a leisure trip from Shirdi. With Sai Shirdi Cab, travelers can book a taxi for a one-way journey, round trip, or multi-day sightseeing plan. The route can be organized around preferred departure times and sightseeing requirements, making the journey more convenient from the beginning."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a popular option for devotees and families planning a pilgrimage journey from Shirdi. Taxi booking through Sai Shirdi Cab provides a practical way to arrange private transportation according to the group's travel schedule. Passengers can plan direct travel, return trips, or combined pilgrimage routes connecting Bhimashankar with other religious destinations."
},
{
title: "Nashik",
description: "Nashik offers a flexible outstation route from Shirdi for religious tours, family travel, business visits, and sightseeing. Sai Shirdi Cab allows passengers to book a taxi in advance for direct Nashik travel or a customized round trip. The journey can also be planned around additional stops and nearby destinations when travelers want to cover more places in one itinerary."
},
{
title: "Goa",
description: "Goa is an attractive long-distance destination for travelers looking to plan a holiday from Shirdi. Booking a taxi with Sai Shirdi Cab can be useful for families and private groups who prefer dedicated transportation instead of sharing a vehicle. One-way and round-trip options can be arranged according to the planned travel dates, duration, luggage, and Goa itinerary."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is suitable for devotees and families planning an outstation pilgrimage from Shirdi. A pre-booked taxi from Sai Shirdi Cab provides convenient door-to-door transportation with a planned pickup and destination schedule. Travelers can choose a direct journey or include Trimbakeshwar as part of a wider religious tour covering multiple Maharashtra destinations."
},
{
title: "Bhandardara",
description: "Bhandardara is a suitable destination for travelers looking for a peaceful nature trip from Shirdi. Families, friends, and small groups can book a private taxi through Sai Shirdi Cab for comfortable transportation throughout the journey. Round-trip and customized sightseeing plans can be arranged when travelers want additional time to explore the destination before returning to Shirdi."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a convenient pilgrimage destination for passengers traveling from Shirdi. Taxi booking with Sai Shirdi Cab makes it easier to plan a private journey with flexible pickup and return arrangements. The cab can also be used for a broader pilgrimage itinerary when travelers want to visit Shani Shingnapur along with other religious destinations."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves provide an excellent option for heritage and sightseeing trips from Shirdi. Travelers can book a private taxi with Sai Shirdi Cab for a direct journey, round trip, or customized sightseeing itinerary. This option works well for families, small groups, and visitors who want the flexibility to spend time at historical attractions without following a fixed shared-tour schedule."
},
{
title: "Saputara",
description: "Saputara is a refreshing outstation destination for families and friends planning a longer leisure journey from Shirdi. Sai Shirdi Cab offers taxi booking for travelers who prefer private transportation and a personalized travel schedule. The trip can be organized as a one-way transfer, return journey, or multi-day tour depending on the selected itinerary and sightseeing plans."
},
{
title: "Pune",
description: "Pune is an important outstation route from Shirdi for business travel, family visits, educational trips, events, and extended sightseeing. With Sai Shirdi Cab, passengers can book a taxi in advance and select a suitable one-way or round-trip travel plan. Private cab transportation makes it easier to manage departure timing, luggage, intermediate stops, and return arrangements."
}
],









"services": [
{
"name": "Taxi Booking in Shirdi",
"description": "Taxi Booking in Shirdi provides a convenient way to arrange private transportation for local sightseeing, railway station transfers, airport travel, pilgrimages, and outstation journeys. Customers can select a suitable vehicle according to their route, passenger count, travel schedule, and trip requirements."
},
{
"name": "Shirdi Taxi Booking",
"description": "Shirdi Taxi Booking makes it easy for travelers to arrange a cab for planned journeys from or within Shirdi. Taxi options can be selected according to the destination, pickup location, number of passengers, luggage, and one-way or round-trip requirements."
},
{
"name": "Shirdi Cab Booking",
"description": "Shirdi Cab Booking offers a practical transportation solution for families, devotees, business travelers, and tourists. Customers can arrange private cabs for local travel, sightseeing, pilgrimage trips, airport transfers, railway station pickups, and outstation routes."
},
{
"name": "taxi booking service in Shirdi",
"description": "Taxi booking service in Shirdi helps travelers organize reliable private transportation for different travel needs. Cabs can be arranged for local destinations, religious tours, airport transfers, railway stations, family trips, and customized outstation journeys."
},
{
"name": "cab booking service in Shirdi",
"description": "Cab booking service in Shirdi provides convenient transportation arrangements for individuals, families, and groups. Travelers can choose suitable cars based on passenger capacity, luggage requirements, travel distance, pickup point, and preferred journey schedule."
},
{
"name": "Shirdi taxi booking online",
"description": "Shirdi taxi booking online allows travelers to plan their cab requirements in advance without visiting a booking office. Customers can provide journey details such as pickup location, destination, travel date, vehicle preference, and one-way or return travel needs."
},
{
"name": "Shirdi cab booking online",
"description": "Shirdi cab booking online provides an easy option for arranging private transportation before the journey begins. It is suitable for devotees, tourists, families, and business travelers requiring cabs for local travel, airport transfers, sightseeing, or outstation trips."
},
{
"name": "online taxi booking Shirdi",
"description": "Online taxi booking Shirdi helps passengers arrange transportation according to their planned itinerary and departure schedule. Private taxi options can be considered for temple visits, local transfers, railway station travel, airport journeys, and long-distance routes."
},
{
"name": "online cab booking Shirdi",
"description": "Online cab booking Shirdi makes it convenient to organize a vehicle for upcoming travel from Shirdi. Customers can share their pickup, drop, travel date, passenger count, and vehicle requirements to plan a suitable cab service."
},
{
"name": "Shirdi taxi reservation",
"description": "Shirdi taxi reservation is useful for travelers who want to arrange their transportation ahead of a scheduled journey. The reservation can be planned for local sightseeing, pilgrimage travel, airport transfers, railway station pickups, family trips, and outstation destinations."
},
{
"name": "Shirdi cab reservation",
"description": "Shirdi cab reservation provides advance transportation planning for passengers traveling within Shirdi or to other destinations. Travelers can arrange suitable cars based on their itinerary, travel duration, passenger requirements, and preferred pickup and drop locations."
},
{
"name": "local taxi booking Shirdi",
"description": "Local taxi booking Shirdi is suitable for passengers traveling around Shirdi for temple visits, sightseeing, railway station transfers, hotels, and nearby attractions. Private cabs provide a convenient option for families, devotees, and visitors who prefer point-to-point transportation."
},
{
"name": "local cab booking Shirdi",
"description": "Local cab booking Shirdi offers convenient transportation for short-distance travel within and around Shirdi. Customers can arrange cabs for hotel transfers, Sai Baba temple visits, local sightseeing, railway station travel, shopping areas, and other planned stops."
},
{
"name": "outstation taxi booking Shirdi",
"description": "Outstation taxi booking Shirdi helps travelers arrange private transportation from Shirdi to cities, tourist destinations, and pilgrimage locations. The service can be planned for one-way journeys, round trips, multi-day travel, and customized routes with multiple stops."
},
{
"name": "outstation cab booking Shirdi",
"description": "Outstation cab booking Shirdi provides a convenient way to organize long-distance private travel from Shirdi. Passengers can choose a suitable vehicle and plan the journey according to the route, travel date, passenger count, luggage, and return requirements."
},
{
"name": "airport taxi booking Shirdi",
"description": "Airport taxi booking Shirdi helps passengers arrange private transportation for airport pickup and drop requirements. It is suitable for individuals, families, and groups who need scheduled travel between Shirdi and nearby airports with convenient luggage accommodation."
},
{
"name": "airport cab booking Shirdi",
"description": "Airport cab booking Shirdi provides an organized travel option for passengers going to or arriving from nearby airports. Customers can schedule a suitable cab according to their flight timing, pickup location, luggage requirements, passenger count, and destination."
},
{
"name": "one way taxi booking Shirdi",
"description": "One way taxi booking Shirdi is ideal for travelers who need a private cab to reach another destination without requiring the vehicle for the return journey. The service can be arranged according to the preferred pickup point, destination, departure time, and vehicle type."
},
{
"name": "round trip taxi booking Shirdi",
"description": "Round trip taxi booking Shirdi provides transportation for both onward and return journeys under a planned travel arrangement. It is suitable for sightseeing tours, pilgrimages, family vacations, business trips, and outstation travel where passengers need a return vehicle."
},
{
"name": "affordable taxi booking in Shirdi",
"description": "Affordable taxi booking in Shirdi offers a practical transportation option for travelers looking to manage their journey within a suitable budget. Customers can choose vehicle options according to their route, passenger requirements, travel duration, and one-way or round-trip plans."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides taxi and cab booking services in Shirdi for local, airport, railway station, pilgrimage, sightseeing, and outstation travel. Customers can arrange suitable vehicles for one-way, round-trip, online booking, family travel, and customized transportation requirements."
}
],
"tableData": [
["Taxi Booking in Shirdi", "Shirdi Taxi Booking"],
["Shirdi Cab Booking", "taxi booking service in Shirdi"],
["cab booking service in Shirdi", "Shirdi taxi booking online"],
["Shirdi cab booking online", "online taxi booking Shirdi"],
["online cab booking Shirdi", "Shirdi taxi reservation"],
["Shirdi cab reservation", "local taxi booking Shirdi"],
["local cab booking Shirdi", "outstation taxi booking Shirdi"],
["outstation cab booking Shirdi", "airport taxi booking Shirdi"],
["airport cab booking Shirdi", "one way taxi booking Shirdi"],
["round trip taxi booking Shirdi", "affordable taxi booking in Shirdi"],
["Sai Shirdi Cabs", "Taxi Booking in Shirdi"]
]
,







whychoose: [  

    {   

        WhyChooseheading: "Taxi Booking in Shirdi for Comfortable Local Travel",   

        WhyChoosedescription: "Sai Shirdi Cabs provides taxi booking services in Shirdi for devotees, families, tourists, business travellers, and visitors looking for convenient transportation. Taxis can be booked for Sai Baba Darshan, hotel transfers, local travel, railway station pickups, airport transfers, sightseeing, and planned journeys to nearby destinations."   

    },   

    {   

        WhyChooseheading: "Easy Taxi Booking Service in Shirdi",   

        WhyChoosedescription: "Booking a taxi in Shirdi provides a practical way to arrange transportation according to your travel schedule. Sai Shirdi Cabs can assist with taxi requirements for individual travellers, families, small groups, pilgrimage visits, sightseeing plans, and transfers between hotels, temples, stations, and other selected locations."   

    },   

    {   

        WhyChooseheading: "Taxi Booking for Sai Baba Darshan",   

        WhyChoosedescription: "Visitors coming to Shirdi for Sai Baba Darshan can book a taxi for transportation between their hotel, accommodation, temple area, railway station, and other planned locations. Taxi travel can be arranged according to the group's schedule and requirements during their pilgrimage visit."   

    },   

    {   

        WhyChooseheading: "Local Taxi Service for Shirdi Sightseeing",   

        WhyChoosedescription: "Tourists and families can book a taxi for Shirdi sightseeing and visits to nearby attractions. The journey can be planned according to the places you want to visit, available travel time, pickup location, and preferred return schedule, making it suitable for short local tours and customized sightseeing plans."   

    },   

    {   

        WhyChooseheading: "Taxi Booking for Shirdi Railway Station Transfers",   

        WhyChoosedescription: "Sai Shirdi Cabs provides taxi booking options for passengers travelling to or from Shirdi Railway Station. Pickup and drop transportation can be planned according to train arrival or departure timings, hotel locations, passenger requirements, luggage, and the destination selected for your journey."   

    },   

    {   

        WhyChooseheading: "Airport Taxi Booking from Shirdi",   

        WhyChoosedescription: "Passengers requiring airport transportation can book a taxi from Shirdi for airport pickup and drop services. The journey can be planned around flight schedules, pickup points, luggage requirements, passenger count, and the required airport destination, providing an organized option for airport travel."   

    },   

    {   

        WhyChooseheading: "Outstation Taxi Booking from Shirdi",   

        WhyChoosedescription: "Travellers can book taxis from Shirdi for outstation journeys to cities, tourist destinations, and pilgrimage places such as Nashik, Mumbai, Pune, Trimbakeshwar, Shani Shingnapur, Chhatrapati Sambhajinagar, and other locations. One-way and round-trip travel requirements can be planned according to the selected route and itinerary."   

    },   

    {   

        WhyChooseheading: "Book Taxi in Shirdi with Sai Shirdi Cabs",   

        WhyChoosedescription: "To book a taxi in Shirdi, provide Sai Shirdi Cabs with your pickup location, destination, travel date, passenger count, luggage details, journey type, sightseeing requirements, and preferred travel schedule. Sharing complete trip information helps in arranging taxi transportation according to your local, pilgrimage, airport, railway station, or outstation travel needs."   

    }   

]   


}; 

const faqData = [ 

{ 

question: "Can I book a taxi in Shirdi?", 

answer: "Yes, Sai Shirdi Cabs provides taxi booking services in Shirdi for local travel, Sai Baba Darshan, sightseeing, railway station transfers, airport transfers, and outstation journeys." 

}, 

{ 

question: "Can I book a taxi for Sai Baba Darshan in Shirdi?", 

answer: "Yes, you can book a taxi for Sai Baba Darshan and transportation between your hotel, temple area, railway station, and other planned locations in Shirdi." 

}, 

{ 

question: "Can I book a taxi for Shirdi sightseeing?", 

answer: "Yes, taxis can be booked for Shirdi sightseeing and nearby attractions according to your preferred destinations, travel duration, pickup point, and sightseeing schedule." 

}, 

{ 

question: "Can I book a taxi from Shirdi Railway Station?", 

answer: "Yes, Sai Shirdi Cabs can arrange taxi pickup and drop services from Shirdi Railway Station according to train arrival or departure timings and your required destination." 

}, 

{ 

question: "Can I book an airport taxi from Shirdi?", 

answer: "Yes, airport taxi services can be arranged from Shirdi according to your flight schedule, pickup location, passenger count, luggage requirements, and airport destination." 

}, 

{ 

question: "Can I book a taxi for outstation travel from Shirdi?", 

answer: "Yes, taxis can be booked from Shirdi for outstation travel to cities, tourist destinations, pilgrimage locations, and other places according to your planned route." 

}, 

{ 

question: "Can I book a one-way taxi from Shirdi?", 

answer: "Yes, one-way taxi bookings can be arranged from Shirdi to your selected destination based on the travel route, pickup location, date, and journey requirements." 

}, 

{ 

question: "Can I book a round-trip taxi in Shirdi?", 

answer: "Yes, round-trip taxi services can be planned for sightseeing, pilgrimage trips, family travel, outstation journeys, and other return travel requirements from Shirdi." 

}, 

{ 

question: "Can I book a taxi for family travel in Shirdi?", 

answer: "Yes, families can book taxis in Shirdi for local transportation, Sai Baba Darshan, sightseeing, hotel transfers, railway station transfers, airport travel, and outstation journeys." 

}, 

{ 

question: "How can I book a taxi in Shirdi?", 

answer: "You can contact Sai Shirdi Cabs with your pickup location, destination, travel date, passenger count, luggage details, journey type, and preferred schedule to arrange your taxi booking in Shirdi." 

} 

]; 

const testimonials = [ 

{ 

id: 1, 

name: "Mr. Amit Deshmukh", 

feedback: "We booked a taxi in Shirdi for Sai Baba Darshan and local sightseeing. The booking process was convenient, and having a taxi available for our planned locations made it easier for our family to manage the day's travel schedule.", 

rating: 5 

}, 

{ 

id: 2, 

name: "Mrs. Priya Patil", 

feedback: "Our family used Sai Shirdi Cabs for a taxi booking during our Shirdi visit. We travelled between the railway station, hotel, temple area, and sightseeing locations, which made our overall transportation much easier to coordinate.", 

rating: 5 

} 

];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Booking in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/taxi-booking-in-shirdi.webp",
  "description":
    "Book a Taxi in Shirdi with Sai Shirdi Cabs for convenient, comfortable, and reliable local and outstation travel. Our Shirdi taxi booking service is suitable for Sai Baba Darshan, local sightseeing, airport transfers, railway station transfers, family trips, business travel, one-way journeys, round trips, and outstation travel. Get well-maintained cars, professional drivers, affordable fares, flexible pickup and drop locations, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/taxi-booking-in-shirdi"
  }
};





    return (
        <div>

<Helmet>
  <title>Taxi Booking in Shirdi | Shirdi Taxi & Cab Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Book a taxi in Shirdi with Sai Shirdi Cabs for Sai Baba Darshan, sightseeing, airport and railway station transfers, one-way, round trips and outstation travel. Get comfortable cars, professional drivers and easy online booking."
  />

  <meta
    name="keywords"
    content="Taxi Booking in Shirdi, Shirdi Taxi Booking, Shirdi Cab Booking, taxi booking service in Shirdi, cab booking service in Shirdi, Shirdi taxi booking online, Shirdi cab booking online, online taxi booking Shirdi, online cab booking Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxibookinginshirdi;